import _ from 'lodash';
import {ProductData, ProductInCatalog} from '@treez/commons/sharedTypings/product';
import {ReducerActionAttributes} from '~/redux/reducers/RootReducer';
import {ProductsPresenceAcrossStores} from '~/utils/ProductAPI';

export enum MergeAction {
    CLEAR_FORM = 'CLEAR_FORM',
    CLEAR_STATE = 'CLEAR_STATE',
    REMOVE_PRODUCT_SOURCE = 'REMOVE_PRODUCT_SOURCE',
    REMOVE_PRODUCT_SOURCE_FROM_ALL = 'REMOVE_PRODUCT_SOURCE_FROM_ALL',
    SET_ALL_PRODUCT_SOURCES = 'SET_ALL_PRODUCT_SOURCES',
    SET_MERGE_TO_PRODUCT = 'SET_MERGE_TO_PRODUCT',
    SET_STORE_PRESENCE = 'SET_STORE_PRESENCE',
    UPDATE_EXACT_MATCHES = 'UPDATE_EXACT_MATCHES',
    UPDATE_PRODUCT = 'UPDATE_PRODUCT',
    UPDATE_PRODUCT_SOURCE = 'UPDATE_PRODUCT_SOURCE',
}

const {
    CLEAR_FORM,
    CLEAR_STATE,
    SET_MERGE_TO_PRODUCT,
    SET_STORE_PRESENCE,
    UPDATE_PRODUCT,
    SET_ALL_PRODUCT_SOURCES,
    REMOVE_PRODUCT_SOURCE,
    REMOVE_PRODUCT_SOURCE_FROM_ALL,
    UPDATE_PRODUCT_SOURCE,
    UPDATE_EXACT_MATCHES,
} = MergeAction;

export const clearMergeProductForm = (): ReducerActionAttributes<MergeAction, undefined> => ({
    type: CLEAR_FORM,
    value: undefined,
});

export const clearMergeState = (): ReducerActionAttributes<MergeAction, undefined> => ({
    type: CLEAR_STATE,
    value: undefined,
});

export const updateMergeProduct = (
    field: ProductData,
    value: any
): ReducerActionAttributes<MergeAction, {field: ProductData; value: any}> => ({
    type: UPDATE_PRODUCT,
    value: {
        field,
        value,
    },
});

export const updateMergeExactMatches = (
    value: ProductData[]
): ReducerActionAttributes<MergeAction, ProductData[]> => ({
    value,
    type: UPDATE_EXACT_MATCHES,
});

export const setMergeToProduct = (
    value: Partial<ProductInCatalog> | ProductInCatalog
): ReducerActionAttributes<MergeAction, Partial<ProductInCatalog> | ProductInCatalog> => ({
    value,
    type: SET_MERGE_TO_PRODUCT,
});

export const setMergeProductStorePresence = (
    value: ProductsPresenceAcrossStores
): ReducerActionAttributes<MergeAction, ProductsPresenceAcrossStores> => ({
    value,
    type: SET_STORE_PRESENCE,
});

export const setAllProductSources = (
    value: Partial<ProductInCatalog>
): ReducerActionAttributes<MergeAction, Partial<ProductInCatalog>> => ({
    type: SET_ALL_PRODUCT_SOURCES,
    value,
});

export const removeProductSource = (
    field: ProductData
): ReducerActionAttributes<MergeAction, {field: ProductData}> => ({
    type: REMOVE_PRODUCT_SOURCE,
    value: {
        field,
    },
});

export const removeProductSourceFromAll = (
    value: Partial<ProductInCatalog>
): ReducerActionAttributes<MergeAction, Partial<ProductInCatalog>> => ({
    type: REMOVE_PRODUCT_SOURCE_FROM_ALL,
    value,
});

export const updateProductSource = (
    field: ProductData,
    value: Partial<ProductInCatalog>
): ReducerActionAttributes<
    MergeAction,
    {field: ProductData; value: Partial<ProductInCatalog>}
> => ({
    type: UPDATE_PRODUCT_SOURCE,
    value: {
        field,
        value,
    },
});
